let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("eufZR"), load("ffEVr"), load("4vd0S")]).then(() => parcelRequire('7FipJ'));